export default "__VITE_ASSET__BwL$_uvI__"